export type ProjectCoverMeta = {
  coverUrl?: string | null
  coverFrame?: number | null
  thumbnailUrl?: string | null
  thumbnail?: string | null
  thumbnailFrame?: number | null
}

function normalizeString(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed.length ? trimmed : null
}

function normalizeNumber(value: unknown): number | null {
  if (typeof value !== 'number') return null
  if (!Number.isFinite(value)) return null
  return value
}

export function resolveProjectCoverUrl(meta?: ProjectCoverMeta | null): string | null {
  if (!meta) return null
  return normalizeString(meta.coverUrl) ?? normalizeString(meta.thumbnailUrl) ?? normalizeString(meta.thumbnail)
}

export function resolveProjectCoverFrame(meta?: ProjectCoverMeta | null): number | null {
  if (!meta) return null
  return normalizeNumber(meta.coverFrame) ?? normalizeNumber(meta.thumbnailFrame)
}
